<template>
    <tr>
        <td>{{ index + 1 }}</td>
        <td>{{ studentData.name }}</td>
        <td>{{ studentData.romaji }}</td>
        <td>{{ studentData.furigana }}</td>
        <td>{{ studentData.class_name }}</td>
        <td>{{ studentData.place_name }}</td>
        <td>{{ getStatus(studentData.status) }}</td>
        <td>{{studentData.time}}</td>
        <td>{{ studentData.checked_in_at }}</td>
        <td>{{ studentData.checked_out_at }}</td>
        <td>
            <div class="history-note">
                <div class="history-note__content">
                    <div v-show="!isEditNote">{{ studentData.note }}</div>
                    <div v-show="isEditNote">
                        <el-input
                            type="textarea"
                            :rows="3"
                            :placeholder="$t('common.note')"
                            v-model="note">
                        </el-input>
                    </div>
                </div>
                <div class="history-note__action">
                    <div class="history-note__action__buttons">
                        <span class="edit-button" v-show="!isEditNote" @click="editNote()">
                            <i class="el-icon-edit"></i>
                        </span>
                        <span class="save-button" v-show="isEditNote" @click="saveNote()">
                            <i class="el-icon-check"></i>
                        </span>
                        <span class="cancel-button" v-show="isEditNote" @click="cancelNote()">
                            <i class="el-icon-close"></i>
                        </span>
                    </div>
                </div>
            </div>
        </td>
        <td>
            <template v-if="canCancel()">
                <el-button type="danger" @click="cancel(studentData)">{{ $t('common.cancel') }}</el-button>
                <el-dialog
                    :title="$t('common.cancel')"
                    :visible.sync="isCancel" @closed="cancelClosed()">
                        <el-input
                            type="textarea"
                            :rows="3"
                            :placeholder="$t('common.note')"
                            v-model="noteCancel">
                        </el-input>
                        <span slot="footer" class="dialog-footer">
                            <el-button @click="cancelCancel()">{{ $t('common.cancel') }}</el-button>
                            <el-button type="primary" @click="submitCancel()">{{ $t('common.submit') }}</el-button>
                        </span>
                </el-dialog>
            </template>
            <template v-if="canBook()">
                <el-button type="primary" @click="book(studentData)">{{ $t('common.book') }}</el-button>
                <el-dialog
                        :title="$t('common.book')"
                        :visible.sync="isBook" @closed="bookClosed()">
                    <el-input
                            type="textarea"
                            :rows="3"
                            :placeholder="$t('common.note')"
                            v-model="noteBook">
                    </el-input>
                    <span slot="footer" class="dialog-footer">
                            <el-button @click="bookCancel()">{{ $t('common.cancel') }}</el-button>
                            <el-button type="primary" @click="submitBook()">{{ $t('common.submit') }}</el-button>
                        </span>
                </el-dialog>
            </template>
        </td>
    </tr>
</template>

<script>
  import { STUDENT_STATUS_CANCEL, STUDENT_NOT_CHECKED_IN, STUDENT_CHECKED_IN, ROUTE_PICKUP } from "../../config"

  export default {
    name: 'BusHistoryPickupRouteItem',
    props: ['student', 'index', 'busId', 'date'],
    components: {

    },
    data: function () {
      return {
        note: null,
        isEditNote: false,
        studentData: this.student,
        noteCancel: '',
        isCancel: false,
        isBook: false,
        noteBook: ''
      }
    },
    methods: {
      getStatus (status) {
        switch (status) {
          case STUDENT_STATUS_CANCEL:
            return this.$t('common.canceled')
          case STUDENT_NOT_CHECKED_IN:
            return this.$t('common.not_checked_in')
          case STUDENT_CHECKED_IN:
            return this.$t('common.checked_in')
          default:
            return this.$t('common.checked_out')
        }
      },
      cancel: function () {
        this.isCancel = true
      },
      book: function () {
        this.isBook = true
      },
      cancelCancel: function () {
        this.isCancel = false
      },
      bookCancel: function () {
        this.isBook = false
      },
      cancelClosed: function () {
        this.noteCancel = ''
      },
      bookClosed: function () {
        this.noteBook = ''
      },
      submitCancel: function () {
        let busId = this.busId
        let date = this.$moment(this.date).format('YYYY-MM-DD')
        let routeType = ROUTE_PICKUP
        let studentId = this.student.id
        let note = this.noteCancel.trim()
        let successCallback = (response) => {
          this.studentData.note = note
          this.studentData.status = STUDENT_STATUS_CANCEL
          this.isCancel = false
        }

        this.$store.dispatch('bus/busHistoryStudentCancel', {
          busId,
          date,
          routeType,
          studentId,
          note,
          successCallback
        })
      },
      submitBook: function () {
        let busId = this.busId
        let date = this.$moment(this.date).format('YYYY-MM-DD')
        let routeType = ROUTE_PICKUP
        let studentId = this.student.id
        let note = this.noteBook.trim()
        let successCallback = (response) => {
          this.studentData.note = note
          this.studentData.status = STUDENT_NOT_CHECKED_IN
          this.isBook = false
        }

        this.$store.dispatch('bus/busHistoryStudentBook', {
          busId,
          date,
          routeType,
          studentId,
          note,
          successCallback
        })
      },
      editNote: function () {
        this.note = this.studentData.note
        this.isEditNote = true
      },
      saveNote: function () {
        let busId = this.busId
        let date = this.$moment(this.date).format('YYYY-MM-DD')
        let routeType = ROUTE_PICKUP
        let studentId = this.student.id
        let note = this.note.trim()
        let successCallback = (response) => {
          this.studentData.note = this.note.trim()
          this.isEditNote = false
        }

        this.$store.dispatch('bus/busHistoryStudentNote', {
          busId,
          date,
          routeType,
          studentId,
          note,
          successCallback
        })
      },
      cancelNote: function () {
        this.isEditNote = false
      },
      canCancel: function () {
        return this.studentData.status === STUDENT_NOT_CHECKED_IN
      },
      canBook: function () {
        let currentDate = this.$moment().format('YYYY-MM-DD')
        let date = this.$moment(this.date).format('YYYY-MM-DD')

        return this.studentData.status === STUDENT_STATUS_CANCEL && date >= currentDate
      }
    },
    computed: {

    }
  }
</script>
<style lang="scss">

</style>
